$ = jQuery.noConflict();

$(document).ready(function(){
	if ( $('.cmyk-qwiet-roi').length ) {
		$('.cmyk-qwiet-roi').each(function(){
			const id = $(this).attr('id');
			
			const state = {
				findings: 100,
				devCost: {
					total: 185000,
					weekly: 3557.69,
					hourly: 88.94
				},
				existing: {
					total: {
						cost: 88942.31,
						hours: 1000
					},
					hours: {
						research: 4,
						fix: 6,
						total: 10
					}
				},
				qwiet: {
					total: {
						cost: 31129.81,
						hours: 350
					},
					hours: {
						research: 1.5,
						fix: 2,
						total: 3.5
					}
				}
			};
			
			const avgDevCostInput = $('#average-cost-' + id);
			const vulnerabilitiesInput = $('#total-vulnerabilities-' + id);
			const weeklyDevCostInput = $('#average-cost-weekly-' + id);
			const hourlyDevCostInput = $('#average-cost-hourly-' + id);
			const researchHoursInput = $('#existing-hours-research-' + id);
			const fixHoursInput = $('#existing-hours-fix-' + id);
			const totalHoursInput = $('#existing-hours-total-' + id);
			const totalHoursText = $('#existing-total-hours-' + id);
			const totalCostText = $('#existing-total-cost-' + id);
			
			const qwietHoursText = $('#qwiet-total-hours-' + id);
			const qwietCostText = $('#qwiet-total-cost-' + id);
			
			const validateNumber = function() {
				const parsed = Number.parseFloat(('' + this.value).replace(',', ''));
				if ( Number.isNaN(parsed) ) {
					$(this).attr('aria-invalid', 'true');
					return false;
				} else if ( parsed < 0 ) {
					$(this).attr('aria-invalid', 'true');
					return false;
				}
				
				this.removeAttribute('aria-invalid');
				
				return parsed;
			};
			
			const updateFormValues = (function() {
				
				const numberFormatter = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 0,
					maximumFractionDigits: 1
				});
				
				const currencyFormatter = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
				
				const animateCurrencyInput = function(el, init, end) {
					const costObj = {
						cost: init
					};
					
					gsap.to(costObj, {
						cost: end,
						duration: 0.8,
						onUpdate: function() {
							if ( $(el).is('input') ) {
								$(el).val( currencyFormatter.format( costObj.cost ) );
							} else {
								$(el).text( currencyFormatter.format( costObj.cost ) );
							}
						}
					});
				};
				
				const animateNumberInput = function(el, init, end) {
					const costObj = {
						cost: init
					};
					
					gsap.to(costObj, {
						cost: end,
						duration: 0.8,
						onUpdate: function() {
							if ( $(el).is('input') ) {
								$(el).val( numberFormatter.format( costObj.cost ) );
							} else {
								$(el).text( numberFormatter.format( costObj.cost ) );
							}
						}
					});
				};
				
				const initDevWeekly = state.devCost.weekly;
				state.devCost.weekly = state.devCost.total / 52;
				const initDevHourly = state.devCost.hourly;
				state.devCost.hourly = state.devCost.weekly / 40;
				
				if ( initDevWeekly !== state.devCost.weekly ) {
					animateCurrencyInput( weeklyDevCostInput, initDevWeekly, state.devCost.weekly );
				} if ( initDevHourly !== state.devCost.hourly ) {
					animateCurrencyInput( hourlyDevCostInput, initDevHourly, state.devCost.hourly );
				}
				
				const totalExistingHours = state.existing.hours.total;
				state.existing.hours.total = state.existing.hours.fix + state.existing.hours.research;
				if ( totalExistingHours !== state.existing.hours.total ) {
					animateNumberInput( totalHoursInput, totalExistingHours, state.existing.hours.total );
				}
				
				const initTotalHours = state.existing.total.hours;
				state.existing.total.hours = state.findings * state.existing.hours.total;
				if ( initTotalHours !== state.existing.total.hours ) {
					animateNumberInput( totalHoursText, initTotalHours, state.existing.total.hours );
				}
				
				const initTotalCost = state.existing.total.cost;
				state.existing.total.cost = state.existing.hours.total * state.devCost.hourly * state.findings;
				if ( initTotalCost !== state.existing.total.cost ) {
					animateCurrencyInput( totalCostText, initTotalCost, state.existing.total.cost );
				}
				
				const initQwietTotalHours = state.qwiet.total.hours;
				state.qwiet.total.hours = state.findings * state.qwiet.hours.total;
				if ( initQwietTotalHours !== state.qwiet.total.hours ) {
					animateNumberInput( qwietHoursText, initQwietTotalHours, state.qwiet.total.hours );
				}
				
				const initQwietTotalCost = state.qwiet.total.cost;
				state.qwiet.total.cost = state.qwiet.hours.total * state.devCost.hourly * state.findings;
				if ( initQwietTotalCost !== state.qwiet.total.cost ) {
					animateCurrencyInput( qwietCostText, initQwietTotalCost, state.qwiet.total.cost );
				}
				
			}).bind(this);
			
			avgDevCostInput.on('change', function(e){
				const boundValidate = validateNumber.bind(e.target);
				const parsed = boundValidate();
				if ( parsed !== false ) {
					state.devCost.total = parsed;
					this.value = new Intl.NumberFormat('en-US', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					}).format(parsed, ).replace('USD', '');
					updateFormValues();
				}
			});
			
			vulnerabilitiesInput.on('input', function(e){
				const indicator = $(this).parent().find('.cmyk-qwiet-roi__main-input__range-indicator');
				indicator.text( this.value );
				indicator.css({
					left: (((this.value - 10) / 990) * 100 ) + '%'
				});
			});
			
			vulnerabilitiesInput.on('change', function(){
				console.log(this.value);
				state.findings = this.value;
				updateFormValues();
			});
			
			researchHoursInput.on('change', function(e){
				const boundValidate = validateNumber.bind(e.target);
				const parsed = boundValidate();
				if ( parsed !== false ) {
					state.existing.hours.research = Math.max(2, parsed);
					this.value = state.existing.hours.research;
					updateFormValues();
				}
			});
			
			fixHoursInput.on('change', function(e){
				const boundValidate = validateNumber.bind(e.target);
				const parsed = boundValidate();
				if ( parsed !== false ) {
					state.existing.hours.fix = Math.max(2, parsed);
					this.value = state.existing.hours.fix;
					updateFormValues();
				}
			});
			
			$(this).find('input.has-numarrows').each(function(){
				const thisRef = this;
				const incArrow = $(this).next().find('.inc');
				const decArrow = $(this).next().find('.dec');
				incArrow.on('click', function(){
					if ( ! thisRef.hasAttribute('aria-invalid') ) {
						$(thisRef).val( Number.parseFloat($(thisRef).val()) + 1 );
						$(thisRef).trigger('change');
					}
				});
				
				decArrow.on('click', function(){
					if ( ! thisRef.hasAttribute('aria-invalid') ) {
						$(thisRef).val( Math.max(Number.parseFloat($(thisRef).val()) - 1, 1) );
						$(thisRef).trigger('change');
					}
				});
			});
		});
	}
});